import axios from "axios"
import {API_URL} from "../App"
import authService from "./AuthService"

export default class Service {

    get = (url) => axios.get(API_URL + url, this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    getWithParams = (url, queryParams) => axios.get(API_URL + url + "?" + new URLSearchParams(queryParams).toString(), this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    post = (url, object) => axios.post(API_URL + url, object, this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    postAsFormData = (url, object) => axios.post(API_URL + url, object, this.header("multipart/form-data"))
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    postFile = (url, object) => axios.post(API_URL + url, object, this.header("multipart/form-data"))
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    postWithoutToken = (url, requestBody) => axios.post(API_URL + url, requestBody)
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    put = (url, object) => axios.put(API_URL + url, object, this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    patch = (url, requestBody) => axios.patch(API_URL + url, requestBody, this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    del = (url) => axios.delete(API_URL + url, this.header())
        .then(response => response.data)
        .catch((error) => this.checkAndThrowError(error))

    checkAndThrowError = (error) => {
        let msg = error.response && error.response.data
        if (msg?.code === "INVALID_TOKEN") {
            authService.logout()
            window.location.reload()
        }
        throw error?.response?.data || {code: "NETWORK_ERROR", message: "Szerver nem elérhető"}
    }

    header = (contentType = "application/json") => {
        const user = JSON.parse(localStorage.getItem("user"))
        if (user && user.accessToken) return {
            headers:
                {
                    Authorization: "Bearer " + user.accessToken,
                    "Content-Type": contentType
                }
        }
        else return {headers: {}}
    }

    uploadFilesWithRequest = (url, method, request, files) => {
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(request)], {type: "application/json"}));
        files.forEach((file) => {
            formData.append('files', file);
        });
        const headers = {'Authorization': 'Bearer ' + authService.getCurrentUser().accessToken};
        return axios({method: method.toLowerCase(), url: API_URL + url, data: formData, headers: headers})
            .then(response => response.data)
            .catch((error) => this.checkAndThrowError(error))
    };
}